<script lang="ts" setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { LanguageIcon } from '@heroicons/vue/24/outline'
  import { SUPPORT_LOCALES } from '@/plugins/i18n'
  import { setPreferredLanguage } from '@/plugins/i18n'
  import type { Locale } from '@/types'
  import { track } from '@vercel/analytics'
  import { preferredLocale } from '@/plugins/i18n'

  const { t } = useI18n({ useScope: 'global' })
  const detailsRef = ref<HTMLDetailsElement>()

  function nativeName(lang: Locale) {
    return new Intl.DisplayNames([lang], { type: 'language' }).of(lang)
  }

  async function setPreferredLanguageHandler(lang: Locale) {
    detailsRef.value?.removeAttribute('open')
    await setPreferredLanguage(lang)
    track('change_language', { lang })
  }
</script>

<template>
  <details ref="detailsRef">
    <summary>
      <LanguageIcon class="size-5" />
      {{ t('nav.language') }}
      <span class="ms-auto uppercase opacity-60">{{ preferredLocale }}</span>
    </summary>
    <ul>
      <li
        v-for="lang in SUPPORT_LOCALES"
        v-show="lang !== preferredLocale"
        :key="lang"
      >
        <a
          href="#"
          class="capitalize"
          @click.prevent="setPreferredLanguageHandler(lang)"
          >{{ nativeName(lang) }}</a
        >
      </li>
    </ul>
  </details>
</template>
